import { Button, FormNumberInput, Modal } from '@/components/UI';
import FormSwitch from '@/components/UI/FormSwitch';
import type { ConfirmationPackTarget } from './types';

interface ConfirmationPackModalProps {
    target: ConfirmationPackTarget | null;
    availableEntityCount: number;
    maxEntities: number;
    setMaxEntities: (value: number) => void;
    bypassCache: boolean;
    setBypassCache: (value: boolean) => void;
    isQueueing: boolean;
    onClose: () => void;
    onQueue: () => void;
}

const ConfirmationPackModal = ({
    target,
    availableEntityCount,
    maxEntities,
    setMaxEntities,
    bypassCache,
    setBypassCache,
    isQueueing,
    onClose,
    onQueue
}: ConfirmationPackModalProps) => {
    return (
        <Modal isOpen={target !== null} size="md" title="Confirmation Backtests" onClose={onClose}>
            {target && (
                <div className="space-y-3">
                    <div className="text-sm text-zinc-400">
                        ruleId={target.screenerRuleId} | entityType={target.entityType} | available entities=
                        {availableEntityCount.toLocaleString()}
                    </div>
                    <FormNumberInput
                        integer
                        helpText="Caps how many experiment entities are queued for the standard confirmation pack."
                        id="opt-confirmation-pack-max-entities"
                        label="Max Entities"
                        max={10000}
                        min={1}
                        value={maxEntities}
                        onValueChange={(value) => {
                            // The cap always has a value, so an empty field keeps the current one.
                            if (value === null) return;

                            setMaxEntities(value);
                        }}
                    />
                    <FormSwitch
                        checked={bypassCache}
                        id="opt-confirmation-pack-bypass-cache"
                        label="Bypass cache"
                        onChange={(e) => setBypassCache(e.target.checked)}
                    />
                    <div className="flex items-center justify-end gap-2 pt-2">
                        <Button variant="secondary" onClick={onClose}>
                            Skip
                        </Button>
                        <Button disabled={isQueueing || availableEntityCount === 0} variant="primary" onClick={onQueue}>
                            {isQueueing ? 'Queueing...' : 'Queue Backtests'}
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default ConfirmationPackModal;
